import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, Input, List, SelectDefault } from '../../components';
import { setUsuario } from './redux/usuariosActions';
import { listarMeusProjetos } from '../meusProjetos/redux/meusProjetosActions';
import { PopoverCentralAjuda } from '../../components/popovercentralajuda/popovercentralajuda';

export default ({ erro: formErro, permissionError, email, setEmail, emailErrado }) => {
  const dispatch = useDispatch();
  const { sistema } = useSelector(state => state.layoutState);
  const { usuario, permissoes, erro } = useSelector(state => state.usuariosState);
  const { listMeusProjetos, paginate } = useSelector(state => state.meusProjetosState);
  const nls = require(`./nls/${sistema.idioma}.json`);

  const nlsContexto = require(`../centralAjuda/nlscontexto/${sistema.idioma}.json`);
  const idarray = [108];
  const idarray1 = [109];

  const handleChange = (e) => {
    if (e.name === 'email') {
      setEmail(e.value); // Atualiza o estado do e-mail no componente pai
    }
    dispatch(setUsuario(e));
    if (e.name === 'perfil') {
      popUsuariopermissionsRules(e.value);
    }
  };


  const popUsuariopermissionsRules = (e) => {
  let permissaoUser = permissoes?.map(permissao => ({
    ...permissao,
  }));

  if (e?.id === 1) {
    permissaoUser = permissoes?.map(permissao => ({
      ...permissao,
      podeVisualizar: true,
      podeEditar: permissao.permissaoEditarProjeto ? true : false,
      podePdcaVer: permissao.permissaoEditarProjeto ? true : false,
      podePdcaGerir: permissao.permissaoEditarProjeto ? true : false,
    }));
  }

  if (e?.id === 2) {
    permissaoUser = permissoes?.map(permissao => ({
      ...permissao,
      podeVisualizar: true,
      podeEditar: permissao.permissaoEditarProjeto ? true : false,
      podePdcaVer: permissao.permissaoEditarProjeto ? true : false,
      podePdcaGerir: permissao.permissaoEditarProjeto ? true : false,
    }));
  }

  if (e?.id === 3) {
    permissaoUser = permissoes?.map(permissao => ({
      ...permissao,
      podeVisualizar: false,
      podeEditar: false,
      podePdcaVer: false,
      podePdcaGerir: false,
    }));
  }

    dispatch(setUsuario({ name: 'permissoes', value: permissaoUser }));
  };




  const popUsuariopermissionsRulesOLD = (e) => {
    let permissaoUser = permissoes?.map(permissao => ({
      ...permissao,
    }));
    if (e?.id === 1) {
      permissaoUser = permissoes?.map(permissao => ({
        ...permissao,
        podeVisualizar: true,
        podeEditar: permissao.permissaoEditarProjeto ? true : false,
      }));
    }
    if (e?.id === 2) {
      permissaoUser = permissoes?.map(permissao => ({
        ...permissao,
        podeVisualizar: true,
        podeEditar: permissao.permissaoEditarProjeto ? true : false,
      }));
    }
    if (e?.id === 3) {
      permissaoUser = permissoes?.map(permissao => ({
        ...permissao,
        podeVisualizar: false,
        podeEditar: false,
      }));
    }
    dispatch(setUsuario({ name: 'permissoes', value: permissaoUser }));
  };

  const headerDefault = [
  {
    column: 'nome',
    text: nls?.tableProjeto,
    className: '',
  },
  {
    column: 'visualizarCustom',
    text: nls?.tableVisualizar,
    className: 'actions',
  },
  {
    column: 'editarCustom',
    text: nls?.tableEditar,
    className: 'actions',
  },
  {
    column: 'pdcaVisualizarCustom',
    text: nls?.tablePdcaVisualizar,
    className: 'actions',
  },
  {
    column: 'pdcaGerirCustom',
    text: nls?.tablePdcaGerir,
    className: 'actions',
  },
];


  const handleCheckboxSelectOLD = (e) => {
    let permissaoUser = usuario.permissoes.map(p =>
      p.id === e.id
        ? {
            ...p,
            ...(e.name === 'podeEditar' && e.value
              ? { podeVisualizar: e.value, [e.name]: e.value }
              : { [e.name]: e.value }),
          }
        : p
    );
    dispatch(setUsuario({ name: 'permissoes', value: permissaoUser }));
  };


  const handleCheckboxSelect = (e) => {
  let permissaoUser = usuario.permissoes.map(p => {
    if (p.id !== e.id) return p;

    // Mantém a regra antiga de Visualizar/Editar exatamente como já existe
    let atualizado = {
      ...p,
      ...(e.name === 'podeEditar' && e.value
        ? { podeVisualizar: e.value, [e.name]: e.value }
        : { [e.name]: e.value }),
    };

    // Regras novas apenas para PDCA

    // Se desligou visualizar, precisa derrubar PDCA também
    if (e.name === 'podeVisualizar' && e.value === false) {
      atualizado.podePdcaVer = false;
      atualizado.podePdcaGerir = false;
    }

    // Se ligou Pdca-Ver, precisa garantir Visualizar
    if (e.name === 'podePdcaVer' && e.value === true) {
      atualizado.podePdcaVer = true;
      atualizado.podeVisualizar = true;
    }

    // Se desligou Pdca-Ver, derruba Pdca-Gerir
    if (e.name === 'podePdcaVer' && e.value === false) {
      atualizado.podePdcaVer = false;
      atualizado.podePdcaGerir = false;
    }

    // Se ligou Pdca-Gerir, liga Pdca-Ver e Visualizar
    if (e.name === 'podePdcaGerir' && e.value === true) {
      atualizado.podePdcaGerir = true;
      atualizado.podePdcaVer = true;
      atualizado.podeVisualizar = true;
    }

    // Garantia final: sem visualizar, sem PDCA
    if (!atualizado.podeVisualizar) {
      atualizado.podePdcaVer = false;
      atualizado.podePdcaGerir = false;
    }

    // Garantia final: projeto sem permissão de edição configurável não pode ter PDCA
    if (!p.permissaoEditarProjeto) {
      atualizado.podePdcaVer = false;
      atualizado.podePdcaGerir = false;
    }

    return atualizado;
  });

  dispatch(setUsuario({ name: 'permissoes', value: permissaoUser }));
};





  const listaPerfil = [
    { id: 2, name: nls.gerente },
    { id: 3, name: nls.padrao },
  ];

  console.log("FORMERRO", formErro)
  const formErro1 = { ...formErro, email: true };


  return (
    <div className='box-gerenciar-usuarios-add'>
      <h5>{nls?.subtitleDetalhes}</h5>
      <div className='colflex col2'>
        <div className="email-input-container">
          <Input
            name='email'
            label={nls?.formEmail}
            value={usuario?.email || ''}
            placeholder={nls?.formEmailPH}
            action={(e) => handleChange(e)}
            disabled={usuario?.id}
            required={{
              erro: emailErrado ? formErro1 : formErro,
              message: emailErrado ? nls?.mensagem?.regex : nls?.mensagem?.obrigatorio,
            }}                        
          />         
        </div>
        <SelectDefault
          name='perfil'
          label={
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {nls?.formPerfil}
              <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray} />
            </div>
          }
          options={usuario.possiveisNovosPerfis ? usuario.possiveisNovosPerfis : listaPerfil}
          selected={usuario?.perfil || {}}
          action={(e) => handleChange(e)}
          textCustom={nls.select}
          optionLabel='name'
          optionValue='id'
          required={{
            erro: formErro,
            message: nls?.mensagem?.obrigatorio,
          }}
        />
      </div>

      <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {nls?.subtitlePermissaoUsuario}
        <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray1} />
      </h5>

      <div className='colflex'>
        <List
          header={headerDefault}
          data={usuario.permissoes}
          
          
          listCustom={(e) => {
          const item = e;

          item.editarCustom = (
            <Checkbox
              type='switch'
              name={e.id}
              checked={e?.podeEditar}
              action={(c) => handleCheckboxSelect({ id: e.id, name: 'podeEditar', value: c.value })}
              text={e?.podeEditar ? nls.tableAtivado : nls.tableDesativado}
              disabled={usuario?.perfil?.id === 1 || !e.permissaoEditarProjeto || usuario?.perfil?.id === 2}
            />
          );

          item.visualizarCustom = (
            <Checkbox
              type='switch'
              name={e.id}
              checked={e?.podeVisualizar}
              action={(c) => handleCheckboxSelect({ id: e.id, name: 'podeVisualizar', value: c.value })}
              text={e?.podeVisualizar ? nls.tableAtivado : nls.tableDesativado}
              disabled={e?.podeEditar || usuario?.perfil?.id === 1 || usuario?.perfil?.id === 2}
            />
          );

          item.pdcaVisualizarCustom = (
            <Checkbox
              type='switch'
              name={e.id}
              checked={e?.podePdcaVer}
              action={(c) => handleCheckboxSelect({ id: e.id, name: 'podePdcaVer', value: c.value })}
              text={e?.podePdcaVer ? nls.tableAtivado : nls.tableDesativado}
              disabled={
                usuario?.perfil?.id === 1 ||
                usuario?.perfil?.id === 2 ||
                !e.permissaoEditarProjeto
              }
            />
          );

          item.pdcaGerirCustom = (
            <Checkbox
              type='switch'
              name={e.id}
              checked={e?.podePdcaGerir}
              action={(c) => handleCheckboxSelect({ id: e.id, name: 'podePdcaGerir', value: c.value })}
              text={e?.podePdcaGerir ? nls.tableAtivado : nls.tableDesativado}
              disabled={
                usuario?.perfil?.id === 1 ||
                usuario?.perfil?.id === 2 ||
                !e.permissaoEditarProjeto
              }
            />
          );

          return item;
        }}


          paginate={false}
          actionPaginate={() => null}
          handlePerPage={() => null}
          nls={nls.paginacao}
        />

        {permissionError && (
          <div style={{ color: 'var(--error-bg)', fontSize: '1em', marginTop: '10px' }}>
            {nls?.mensagem?.usuarioPadraoPermissao}
          </div>
        )}
      </div>
    </div>
  );
};